// actioncableに関するstore

import axios from "axios";

import consts from '../../utils/consts'

axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

const state = {
  connect_status: consts.ACTION_CABLE.DEFAULT,
}


const getters = {
  connect_status(state) {
    return state.connect_status;
  },
}


const actions = {
}


const mutations = {
  // 接続OK状態
  setConnectedOk (state) {
    state.connect_status = consts.ACTION_CABLE.CONNETED
 },
  // 接続NG状態
  setConnectedNg (state) {
    state.connect_status = consts.ACTION_CABLE.DIS_CONNECTED
 },
 // 接続対象外
  setConnectedNonTarget (state) {
    state.connect_status = consts.ACTION_CABLE.NON_TARGET
 },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
